import { render, staticRenderFns } from "./Pricing-fr.vue?vue&type=template&id=1821e414&scoped=true&"
import script from "./Pricing-fr.vue?vue&type=script&lang=js&"
export * from "./Pricing-fr.vue?vue&type=script&lang=js&"
import style0 from "./Pricing-fr.vue?vue&type=style&index=0&id=1821e414&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1821e414",
  null
  
)

export default component.exports